import { toast } from 'react-toastify';

export function showToaster(message: string) {
  return toast(message);
}

export function showSuccessToaster(message: string) {
  return toast.success(message);
}

export function showErrorToaster(message: string) {
  return toast.error(message);
}

export function showWarningToaster(message: string) {
  return toast.warn(message);
}
